<template>
  <div class="content">
    <div
      class="u-success"
      :style="{
        display: extraItem.extras('successImg.display') == 0 ? 'none' : 'block',
      }"
    >
      <img :src="extraItem.extras('successImg.src')" alt="" />
    </div>
    <div
      class="t-success"
      :style="{
        color: extraItem.extras('successTitle.color'),
        fontSize: pxOrVw(extraItem.extras('successTitle.size')),
        fontWeight:
          extraItem.extras('successTitle.weight') == 'default'
            ? '500'
            : extraItem.extras('successTitle.weight'),
        display:
          extraItem.extras('successTitle.display') == 0 ? 'none' : 'block',
      }"
    >
      {{ extras | extra("successTitle.model") }}
    </div>
    <div
      class="t-success-desc"
      :style="{
        color: extraItem.extras('successText.color'),
        fontSize: pxOrVw(extraItem.extras('successText.size')),
        fontWeight:
          extraItem.extras('successText.weight') == 'default'
            ? '400'
            : extraItem.extras('successText.weight'),
        display:
          extraItem.extras('successText.display') == 0 ? 'none' : 'block',
      }"
    >
      {{ extras | extra("successText.model") }}
    </div>
    <div class="t-success-desc" v-if="isShowAgain">
      再次填写，请点击这里<span class="u-again" @click="goIndex">→GO!</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "SuccessCon",
  props: ["extras", "platform", "isShowAgain"],
  data() {
    return {
      d: window.$sk.template.get().common,
    };
  },
  methods: {
    goIndex() {
      this.$router.push({
        path: `${this.platform}_index`,
        query: this.d.router,
      });
    },
  },
};
</script>
